export { default } from "./DoctorAd";
